// @ts-nocheck
import { useState, useEffect, useMemo, useRef } from 'react';
import useCustomForm from 'pages/Forms/context/useCustomForm';
import { Element } from 'pages/Forms/RegisterForm/CustomFormBuilder/Header/type/preview.type';
import { UpdateAnswerInPrefilledElements } from 'pages/Forms/RegisterForm/types/shareForm';

const useYesNoNaField = (
  element: Element,
  answer: string,
  handleDirty?: () => void,
  updateAnswerInPrefilledElements?: UpdateAnswerInPrefilledElements,
) => {
  const textFieldRef = useRef<HTMLInputElement>(null);

  const [selectedChoice, setSelectedChoice] = useState<string>('');
  const [otherText, setOtherText] = useState<string>('');
  const [, { setAnswer, setSelectedLinkListLabel }] = useCustomForm();

  const otherChoice = element.choice?.find((choice) => choice.isOtherField);

  const isOtherSelected = useMemo(
    () => selectedChoice === otherChoice?.id,
    [selectedChoice, otherChoice],
  );

  useEffect(() => {
    if (answer) {
      const otherField = element.choice?.find((choice) => choice.isOtherField);

      if (otherField && answer === otherField.id) {
        setSelectedChoice(otherField.id);
        setOtherText(element?.selectedLinkListLabel || '');
      } else {
        setSelectedChoice(answer);
        setOtherText('');
      }
    } else {
      setSelectedChoice('');
      setOtherText('');
    }
  }, [answer]);

  const handleSelectionChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const newValue = event.target.value;

    const selectedChoice = element.choice?.find(
      (choice) => choice.id === newValue,
    );

    const isOtherChoice = selectedChoice?.isOtherField;

    setSelectedChoice(newValue);

    if (isOtherChoice) {
      setSelectedLinkListLabel(element.id, '');
      setTimeout(() => textFieldRef.current?.focus(), 0);
    } else {
      setOtherText('');
    }

    setAnswer(element.id, newValue);
    if (updateAnswerInPrefilledElements) {
      updateAnswerInPrefilledElements(
        element?.id,
        newValue,
        element?.type,
        element?.selectedLinkListLabel,
      );
    }
    handleDirty?.();
  };

  const handleOtherTextChange = (value: string) => {
    setOtherText(value);
    setSelectedLinkListLabel(element.id, value);
    if (updateAnswerInPrefilledElements) {
      updateAnswerInPrefilledElements(
        element?.id,
        answer,
        element?.type,
        value,
      );
    }
    handleDirty?.();
  };

  const clearSelection = () => {
    setSelectedChoice('');
    setAnswer(element.id, '');
    if (updateAnswerInPrefilledElements) {
      updateAnswerInPrefilledElements(element?.id, '', element?.type, '');
    }
    handleDirty?.();
    setOtherText('');
    if (isOtherSelected) {
      setSelectedLinkListLabel(element.id, '');
    }
  };

  const selectedChoiceObj = element.choice?.find(
    (choice) => choice.id === selectedChoice,
  );

  const isShowActionMessage =
    selectedChoiceObj?.action && element?.actionMessage?.trim();

  const isRadioGroupType = element.type === 'radiogroup';
  const isYesNoNaType =
    element.type === 'yesno' || element.type === '"yesnona"';

  return {
    selectedChoice,
    otherText,
    handleSelectionChange,
    handleOtherTextChange,
    clearSelection,
    isShowActionMessage,
    isRadioGroupType,
    isYesNoNaType,
    otherChoice,
    isOtherSelected,
    textFieldRef,
  };
};

export default useYesNoNaField;
